import { METRICS_TYPES } from '@shared/constants/MetricsTypeConstants';

export const UNTAGGED = 'untagged';
export const MULTIPLE_STRATEGIES = 'Multiple Strategies';

export const METRICS_TO_CONSOLIDATE = [
    'budget',
    'clicks',
    'cost',
    'conversions',
    'revenue',
    'impressions',
    'projected_clicks',
    'projected_conversions',
    'projected_cost',
    'projected_revenue',
    'quality_score',
];

export const FIXED_COLUMNS_SEGMENTS_TABLE = [
    {
        value: 'name',
        type: METRICS_TYPES.string,
        label: 'Segments',
    },
    {
        value: 'bidStrategy',
        type: 'string',
        label: 'Bid Strategy',
    },
];

export const FIXED_COLUMNS_OBM_TABLE = [
    {
        value: 'cluster_name',
        type: METRICS_TYPES.string,
        label: 'Clusters',
    },
    {
        value: 'bidStrategy',
        type: 'string',
        label: 'Bid Strategy',
    },
    {
        label: 'Budget Manager',
        value: 'status_budget_manager',
        type: 'bool',
    },
    {
        label: 'Target Manager',
        value: 'status_bid_manager',
        type: 'bool',
    },
    {
        label: 'Monthly Budget',
        value: 'monthly_budget',
        type: METRICS_TYPES.currency,
    },
];

export const segmentsMetrics = [
    {
        value: 'name',
        type: METRICS_TYPES.string,
        label: 'Segments',
    },
    {
        value: 'bidStrategy',
        type: 'string',
        label: 'Bid Strategy',
    },
    {
        value: 'clicks',
        type: 'integer',
        label: 'Clicks',
    },
    {
        value: 'cost',
        type: 'integer',
        label: 'Cost',
    },
    {
        value: 'impressions',
        type: METRICS_TYPES.integer,
        label: 'Impressions',
    },
    {
        value: 'roas',
        type: 'integer',
        label: 'Roas',
    },
    {
        value: 'cpv',
        type: 'integer',
        label: 'CPV',
    },
    {
        value: 'cpa',
        type: 'integer',
        label: 'CPA',
    }, {
        value: 'ctr',
        type: 'percent',
        label: 'CTR',
    },
    {
        label: 'Conversions',
        value: 'conversions',
        type: METRICS_TYPES.float,
    },
];
